import styles from "./index.styles.css?inline";
export { styles };
export const HIDE_FOCUS_CLASS = "body--hideFocusOnMouseClick";
const SHOW_ACCESSIBILITY_KEYS = [
	9, // tab
	37, // left arrow
	38, // up arrow
	39, // right arrow
	40, // down arrow
];
const DO_NOTHING_KEYS = [
	13, // enter
	32, // space
	189, // minus
	187, // equal
];

export const isInAcessibilityMode = () =>
	!document.querySelector("body").classList.contains(HIDE_FOCUS_CLASS);

function addEvent(element, eventName, callback) {
	if (element.addEventListener) {
		element.addEventListener(eventName, callback, false);
	} else if (element.attachEvent) {
		element.attachEvent("on" + eventName, callback);
	} else {
		element["on" + eventName] = callback;
	}
}

export default () => {
	const body = document.body;
	if (!body) {
		return;
	}
	body.classList.add(HIDE_FOCUS_CLASS);
	addEvent(document, "keydown", function (evt) {
		const e = evt || window.event;
		const keypress = parseInt(e.keyCode);
		if (DO_NOTHING_KEYS.includes(keypress)) {
			return; // Do nothing keys don't change accesibility state
		}
		if (SHOW_ACCESSIBILITY_KEYS.includes(keypress)) {
			body.classList.remove(HIDE_FOCUS_CLASS);
		} else {
			body.classList.add(HIDE_FOCUS_CLASS);
		}
	});

	addEvent(body, "mousedown", function (evt) {
		body.classList.add(HIDE_FOCUS_CLASS);
	});
};
